//#region src/components/Banner/Banner.module.css
var e = "_critical_jlbfz_1", t = "_moderate_jlbfz_7", n = "_info_jlbfz_13", r = "_banner_jlbfz_19", i = "_text_jlbfz_30", a = "_closeButton_jlbfz_34", o = "_closeIcon_jlbfz_39", s = "_actionButton_jlbfz_47", c = "_bannerWithActions_jlbfz_52", l = "_absoluteIcon_jlbfz_56", u = {
	critical: e,
	moderate: t,
	info: n,
	banner: r,
	text: i,
	closeButton: a,
	closeIcon: o,
	actionButton: s,
	bannerWithActions: c,
	absoluteIcon: l
};
//#endregion
export { l as absoluteIcon, s as actionButton, r as banner, c as bannerWithActions, a as closeButton, o as closeIcon, e as critical, u as default, n as info, t as moderate, i as text };
